<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col sm="12" md="10">
        <ProjectFormNew />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ProjectFormNew from "../../components/Project/ProjectFormNew";
export default {
  name: "ProjectCreate",
  components: { ProjectFormNew }
}
</script>
